import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  boxMessageContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(0.5),
    position: 'relative'
  },
  messageContainerWithReactions: {
    marginBottom: 12 // Espaço extra quando há reações
  },
  containerBoxRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'relative'
  },
  containerBoxLeft: {
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative'
  },
  reactionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '& .MuiIconButton-root': {
      '& svg': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main
      }
    }
  },
  reactionButton: {
    padding: '6px !important',
    minWidth: '0'
  },
  boxRight: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 6px ',
    margin: '10px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_500.main
        : theme.palette.blue_50.main,
    flex: 1,
    maxWidth: 220,
    borderRadius: 10,
    borderBottomRightRadius: 0
    // fontFamily: 'Noto Color Emoji, sans-serif',
  },
  menuContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  nameSender: {
    fontWeight: '600',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  menuActionButton: {
    padding: '0 !important',
    minWidth: '0',
    '&.MuiIconButton-root': {
      padding: '0 !important'
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  quotedMessage: {
    marginBotton: 5,
    marginTop: 5,
    borderWidth: '0 0 0 5px',
    borderStyle: 'solid',
    borderColor: theme.palette.green_200.main,
    paddingLeft: 5,
    maxHeight: 50,
    overflow: 'hidden'
  },
  quotedMessageSender: {
    fontWeight: '600',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  messageText: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    width: '100%',
    maxWidth: '200px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    boxSizing: 'border-box',
    '& p': { fontFamily: 'Roboto, sans-serif' }
  },
  messageMedia: {
    objectFit: 'cover',
    width: 250,
    height: 200,
    borderRadius: 8,
    marginBottom: theme.spacing(1)
  },
  audioContainer: {
    width: '100%',
    height: '30px',
    marginBottom: '5px'
  },
  downloadMedia: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'inherit',
    padding: 10
  },
  timestamp: {
    display: 'flex',
    justifyContent: 'flex-end',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '& span': {
      fontSize: '0.7rem'
    }
  },
  boxLeft: {
    padding: '10px',
    margin: '10px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    position: 'relative',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_50.main,
    maxWidth: 220,
    borderRadius: 10,
    borderTopLeftRadius: 0,
    // fontFamily: 'Noto Color Emoji, sans-serif'
  },
  reactionsContainer: {
    position: 'absolute',
    bottom: '-18px',
    zIndex: 1
  },
  reactionsContainerLeft: {
    left: '10px'
  },
  reactionsContainerRight: {
    right: '10px'
  },
  reactions: {
    display: 'flex',
    gap: '2px',
    borderRadius: '8px',
    padding: '2px 6px'
  },
  reactionsLeft: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_300.main
        : theme.palette.white_100.main,
    border: '1px solid',
    borderColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main
  },
  reactionsRight: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_500.main
        : theme.palette.blue_50.main,
    border: '1px solid',
    borderColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_stroke.main
  },
  reactionItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    cursor: 'pointer',
    padding: '2px 4px',
    borderRadius: '10px',
    transition: 'background-color 0.2s',
    fontFamily: '"Roboto", "Noto Color Emoji", sans-serif',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)'
    }
  },
  reactionCount: {
    fontSize: '.75rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    marginLeft: '2px'
  }
}))
